import { Button } from "@material-ui/core";
import { useWeb3React } from "@web3-react/core";
import React, { useState } from "react";
import { UserContext } from "src/context/User";
import ConnectWallet from "./ConnectWalletPopUp";

export default function MintButton(props) {
  const { account } = useWeb3React();
  const [openWalletConnect, setOpenWalletConnect] = useState(false);

  return (
    <>
      {openWalletConnect && (
        <ConnectWallet
          open={openWalletConnect}
          handleClose={() => setOpenWalletConnect(false)}
        />
      )}

      {account ? (
        <Button variant='contained' color='primary' size='large' {...props}>
          Mint {props.children}
        </Button>
      ) : (
        <Button
          variant='contained'
          color='primary'
          size='large'
          onClick={() => setOpenWalletConnect(true)}
          fullWidth={props.fullWidth ? true : false}
        >
          Connect
        </Button>
      )}
    </>
  );
}
